import axois, { AxiosInstance } from "axios";
import { BaseApiService } from "../api-base";
import { RunParserRequest } from "./dto";

export class TdlApiService extends BaseApiService {
  constructor(host: string) {
    super("tdl");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }

  run_parser(data: RunParserRequest) {
    const method = `${this.url}/run_parser`;
    const body = {
      app_ref: this.app_ref,
      ...data,
    };
    return this.http.post(method, body).then((response) => response.data);
  }

  info() {
    const method = `${this.url}/info`;
    return this.http.get(method).then((response) => response.data);
  }

  cancel_task(bot_id: number) {
    const method = `${this.url}/cancel_task`;
    const body = { id: bot_id };
    return this.http.post(method, body).then((response) => response.data);
  }
}
